import type { DateTime } from "luxon";
import IdentityObject from "@/src/domain/common/identity-object";
import type MeasurementResponse from "@/src/domain/models/measurement-response";
import type PaginatedFlowMeasurementResponse from "@/src/domain/models/paginated-flow-measurement-response";

export default abstract class MeasurementService extends IdentityObject {
  abstract fetchTotalFlowMeasurement(deviceId: number): Promise<MeasurementResponse>;
  abstract fetchPaginatedFlowMeasurements(
    deviceId: number,
    startDate: DateTime,
    endDate: DateTime,
    currentPage: number
  ): Promise<PaginatedFlowMeasurementResponse>;
}
